<template>
    <div class="container-fluid">
        <div class="card card-primary card-outline" style="background-image: url('images/heading.jpg');background-size: cover;background-repeat: no-repeat;">
            <div class="card-body">
                <div class="form-group" >
                    <div class="p-2 mb-1 bg-secondary text-white">
                        <label> <b>Basic Details</b></label>
                    </div>
                    <div class="row form-group">
                        <template>
                            <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12">
                                <label class="required" style='font-weight: bold;font-family: "Times New Roman", Times, serif;'>CID No/Reference  : </label>
                                <label class="text-primary">{{std_admission_details.CidNo}}</label>
                            </div>
                            <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12">
                                <label class="required" style='font-weight: bold;font-family: "Times New Roman", Times, serif;' >Name of Student :</label>
                                <label class="text-primary">{{ std_admission_details.Name}}</label>
                            </div>
                            <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12">
                                <label class="required" style='font-weight: bold;font-family: "Times New Roman", Times, serif;' >Gender :</label>
                                <label class="text-primary">{{ genderArray[std_admission_details.CmnSexId]}}</label>
                            </div>
                        </template>
                        <template>
                            <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12">
                                <label class="required" style='font-weight: bold;font-family: "Times New Roman", Times, serif;'>Student Code: </label>
                                <label class="text-primary">{{std_admission_details.student_code}}</label>
                            </div>
                            <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12">
                                <label class="required" style='font-weight: bold;font-family: "Times New Roman", Times, serif;' >Date of Birth :</label>
                                <label class="text-primary">{{ std_admission_details.DateOfBirth}}</label>
                            </div>
                            <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12">
                                <label class="required" style='font-weight: bold;font-family: "Times New Roman", Times, serif;' >Academic Year :</label>
                                <label class="text-primary">{{ this.Year}}</label>
                            </div>
                        </template>
                        <!-- class_section_stream_details -->
                        <template>
                            <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12">
                                <label class="required" style='font-weight: bold;font-family: "Times New Roman", Times, serif;'>Class: </label>
                                <label class="text-primary">{{this.class}}</label>
                            </div>
                            <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12">
                                <label class="required" style='font-weight: bold;font-family: "Times New Roman", Times, serif;' >Section :</label>
                                <label class="text-primary">{{ this.section}}</label>
                            </div>
                            <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12">
                                <label class="required" style='font-weight: bold;font-family: "Times New Roman", Times, serif;' >Stream :</label>
                                <label class="text-primary">{{ this.stream}}</label>
                            </div>
                        </template>
                    </div>
                </div>
                <div class="form-group" >
                    <div class="p-1 mb-1 bg-secondary text-white">
                        <label> <b>School Details</b></label>
                    </div>
                    <div class="row form-group">
                        <template>
                            <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12">
                                <label class="required" style='font-weight: bold;font-family: "Times New Roman", Times, serif;'>Dzongkhag/Thromde: </label>
                                <label class="text-primary">{{studentDetails.dzongkhag}}</label>
                            </div>
                            <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12">
                                <label class="required" style='font-weight: bold;font-family: "Times New Roman", Times, serif;' >Gewog :</label>
                                <label class="text-primary">{{ studentDetails.gewog}}</label>
                            </div>
                            <!-- <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12">
                                <label class="required" style='font-weight: bold;font-family: "Times New Roman", Times, serif;' >Chiwog :</label>
                                <label class="text-primary">{{ studentDetails.chewog}}</label>
                            </div> -->
                        </template>
                        <template>
                            <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12">
                                <label class="required" style='font-weight: bold;font-family: "Times New Roman", Times, serif;'>School: </label>
                                <label class="text-primary">{{studentDetails.name}}</label>
                            </div>
                            <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12">
                                <label class="required" style='font-weight: bold;font-family: "Times New Roman", Times, serif;' >Level :</label>
                                <label class="text-primary">{{ studentDetails.level_name}}</label>
                            </div>
                            <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12">
                                <label class="required" style='font-weight: bold;font-family: "Times New Roman", Times, serif;' >School Type :</label>
                                <label class="text-primary" v-if="studentDetails.category=='public_school'">Public School</label>
                                <label class="text-primary" v-else-if="studentDetails.category=='public_ecr'">Public ECR</label>
                                <label class="text-primary" v-else-if="studentDetails.category=='public_eccd'">Public ECCD</label>
                                <label class="text-primary" v-else-if="studentDetails.category=='private_eccd'">Private ECCD</label>
                                <label class="text-primary" v-else>Private School</label>
                            </div>
                        </template>
                    </div>
                </div>
            </div>
        </div>
        <div class="alert alert-info alert-dismissible">
                <button type="button" class="close" data-dismiss="alert" aria-hidden="true">&times;</button>
                <h5><i class="icon fas fa-exclamation-triangle"></i> Information!</h5>
                <div id="message"></div>
        </div>
        <div id="result">
            <div class="row form-group">
                <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                    <label style="font-weight: bold; font-family: 'Times New Roman', Times, serif">Academic Year:<span class="text-danger">*</span></label>
                    <select class="form-control select2" id="academic_year" v-model="student_form.academic_year">
                    <option v-for="year in academicYears" :key="year" :value="year">{{ year }}</option>
                    </select>
                    <has-error :form="student_form" field="academic_year"></has-error>
                    <span class="text-danger" id="academic_year_err"></span>
                </div>

                <!-- added term in dropdown for viewing term wise -->
                <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                <label style='font-weight: bold;font-family: "Times New Roman", Times, serif'>Term:<span class="text-danger">*</span></label> 
                    <select class="form-control select2" id="term" v-model="student_form.term" v-if="termStatus === 'common'">
                        <option v-for="(item, index) in commonExam" :key="index"  :value="item.id">{{item.label}}</option>
                    </select>

                    <select class="form-control select2" id="term" v-model="student_form.term" v-else>
                        <option v-for="(item, index) in normalClasses" :key="index" :value="item.id">{{item.label}}</option>
                    </select>
                    <has-error :form="student_form" field="term"></has-error>
                    <span class="text-danger" id="term_err"></span>
                </div>
            </div>
            <div class="alert alert-info">
                <button type="button" class="close" ></button>
                    <h5><i class="icon fas fa-exclamation-triangle"></i> Information!</h5>
                    <div class="text-primary">
                            <i>(The Results from the portal are only for your information. Any print out of the result will not be considered as an official result of the student )</i>
                    </div>
            </div>
            <div class="row">
                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <div class="card card-outline">
                        <div class="card-header p-0 border-bottom-0 nav nav-pills flex-column flex-sm-row">
                            <ul class="nav nav-tabs" id="custom-tabs-four-tab" role="tablist">
                                <li class="nav-item border-left border-right" id="resultH">
                                    <a class="nav-link active" id="basicdetails-tab" data-toggle="pill" href="#basicdetails" role="tab" aria-controls="basicdetails" aria-selected="true">Result Details</a>
                                </li>
                                <li class="nav-item border-left border-right" id="personalH">
                                    <a class="nav-link" id="parents_tab-tab" data-toggle="pill" href="#parents_tab" role="tab" aria-controls="parents_tab" aria-selected="false">Personal Characteristics</a>
                                </li>
                            </ul>
                        </div>

                        <!-- for term 1 -->
                        <div class="card-body" id="term1">
                            <div class="tab-content">
                                <!-- <div class="active tab-pane" id="basicdetails"> -->
                                <div class="tab-pane fade show active" id="basicdetails" role="tabpanel" aria-labelledby="basicdetails-tab">
                                    <div class="form-group row">
                                        <div class="card-body col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                            <div class="form-group table-responsive">
                                                <table  class="table table-sm table-bordered table-striped ">
                                                    <thead class="p-3 mb-2 bg-secondary text-white border border-info">
                                                        <tr>
                                                            <th class="text-start" style='font-weight: bold;font-family: "Times New Roman", Times, serif;width:7%'>SN</th>
                                                            <th class="text-start" style='font-weight: bold;font-family: "Times New Roman", Times, serif;width:20%'>Subjects Name</th> 
                                                            <th class="text-start" style='font-weight: bold;font-family: "Times New Roman", Times, serif;width:20%'>Continuous Assessment</th> 
                                                            <th class="text-start" style='font-weight: bold;font-family: "Times New Roman", Times, serif;width:20%'>Written Exam</th> 
                                                            <th class="text-start" style='font-weight: bold;font-family: "Times New Roman", Times, serif;width:20%'>Total</th> 
                                                        </tr>
                                                    </thead>
                                                    <tbody id="FinalResult">
                                                        <tr v-for="(item, index) in CsaResultLists" :key="index">
                                                            <td><span class="badge badge-sucess">{{ index + 1 }}.</span></td>
                                                            <td>{{item.subject}}</td>
                                                            <td v-if="item.is_ca_passed=='1'">{{ item.ca_score}} / {{ item.ca_weightage }}</td>
                                                            <td v-else><span class="text-danger">{{ item.ca_score}} / {{ item.ca_weightage }}</span></td>
                                                            <td v-if="item.is_exam_passed=='1'">{{ item.exam_score}} / {{ item.exam_weightage }}</td>
                                                            <td v-else><span class="text-danger">{{ item.exam_score}} / {{ item.exam_weightage }}</span></td>
                                                            <td>{{ item.total }} / {{ item.total_weightage }}</td>
                                                        </tr>
                                                        <template>
                                                            <tr v-if="this.promoted=='1'">
                                                                <td colspan="4" class="text-right">Status:</td>
                                                                <td colspan="1" class="text-success"><b>Pass</b></td>
                                                            </tr>
                                                            <tr v-else >
                                                                <td colspan="4" class="text-right">Result:</td>
                                                                <td colspan="1" class="text-danger"><b>Fail</b></td>
                                                            </tr>
                                                            <tr v-if="this.promoted=='1'">
                                                                <td colspan="4" class="text-right">Percentage:</td>
                                                                <td colspan="1"><b>{{this.percentage}} %</b></td>
                                                            </tr>
                                                            <tr v-if="this.promoted=='1'">
                                                                <td colspan="4" class="text-right">Position:</td>
                                                                <td colspan="1"><b>{{this.class_position}}</b></td>
                                                            </tr>
                                                            <tr>
                                                                <td colspan="2" class="text-right">Attendance Days:</td>
                                                                <td colspan="1"><b>{{this.no_of_days_attended}}/{{ this.instructional_day }}</b></td>
                                                                <td colspan="1" class="text-right">Attendance Percentage:</td>
                                                                <td colspan="1"><b>{{this.attendance}} %</b></td>
                                                            </tr>
                                                        </template>
                                                        
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- term 2 and final -->
                        <div class="card-body" id="term2">
                            <div class="tab-content">
                                <div class="tab-pane fade show active" id="basicdetails" role="tabpanel" aria-labelledby="basicdetails-tab">
                                    <div class="form-group row">
                                        <div class="card-body col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                            <div class="form-group table-responsive">
                                                <table  class="table table-sm table-bordered table-striped ">
                                                    <thead class="p-3 mb-2 bg-secondary text-white border border-info">
                                                        <tr>
                                                            <th class="text-start" style='font-weight: bold;font-family: "Times New Roman", Times, serif;width:7%'>SN</th>
                                                            <th class="text-start" style='font-weight: bold;font-family: "Times New Roman", Times, serif;width:20%'>Subjects Name</th> 
                                                            <th class="text-start" style='font-weight: bold;font-family: "Times New Roman", Times, serif;width:20%'>Continuous Assessment</th> 
                                                            <th class="text-start" style='font-weight: bold;font-family: "Times New Roman", Times, serif;width:20%'>Written Exam </th> 
                                                            <th class="text-start" style='font-weight: bold;font-family: "Times New Roman", Times, serif;width:20%'>Total </th> 
                                                        </tr>
                                                    </thead>
                                                    <tbody id="FinalResult">
                                                        <tr v-for="(item, index) in CsaResultLists" :key="index">
                                                            <td><span class="badge badge-sucess">{{ index + 1 }}.</span></td>
                                                            <td>{{item.subject}}</td>
                                                            <td v-if="item.is_ca_passed=='1'">{{ item.ca_score}}  / {{ item.ca_weightage }}</td>
                                                            <td v-else><span class="text-danger">{{ item.ca_score}}  / {{ item.ca_weightage }}</span></td>
                                                            <td v-if="item.is_exam_passed=='1'">{{ item.exam_score}} / {{ item.exam_weightage }}</td>
                                                            <td v-else><span class="text-danger">{{ item.exam_score}}/ {{ item.exam_weightage }}</span></td>
                                                            <td>{{ item.total }}</td>
                                                        </tr>
                                                        <template id="status">
                                                            <tr v-if="this.promoted=='1'">
                                                                <td colspan="4" class="text-right">Status:</td>
                                                                <td colspan="1" class="text-success"><b>Pass</b></td>
                                                            </tr>
                                                            <tr v-else >
                                                                <td colspan="4" class="text-right">Result:</td>
                                                                <td colspan="1" class="text-danger"><b>Fail</b></td>
                                                            </tr>
                                                            <tr v-if="this.promoted=='1'">
                                                                <td colspan="4" class="text-right">Percentage:</td>
                                                                <td colspan="1"><b>{{this.percentage}} %</b></td>
                                                            </tr>
                                                            <tr v-if="this.promoted=='1'">
                                                                <td colspan="4" class="text-right">Position:</td>
                                                                <td colspan="1"><b>{{this.class_position}}</b></td>
                                                            </tr>
                                                            <tr>
                                                                <td colspan="2" class="text-right">Attendance Days:</td>
                                                                <td colspan="1"><b>{{this.no_of_days_attended}}/{{ this.instructional_day }}</b></td>
                                                                <td colspan="1" class="text-right">Attendance Percentage:</td>
                                                                <td colspan="1"><b>{{this.attendance}} %</b></td>
                                                            </tr>
                                                        </template>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="tab-pane fade" id="parents_tab" role="tabpanel" aria-labelledby="parents_tab-tab">
                                    <div class="card">
                                        <div class="row form-group">
                                            <div class="card-body col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                                <div class="form-group table-responsive">
                                                    <table class="table table-sm table-bordered table-striped ">
                                                        <thead class="p-3 mb-2 bg-secondary text-white border border-info">
                                                            <tr>
                                                                <th class="text-start" style='font-weight: bold;font-family: "Times New Roman", Times, serif'>SN</th>
                                                                <th class="text-start" style='font-weight: bold;font-family: "Times New Roman", Times, serif'>Assessment Area</th> 
                                                                <th class="text-start" style='font-weight: bold;font-family: "Times New Roman", Times, serif'>Score Description</th> 
                                                            </tr>
                                                        </thead>
                                                        <tbody id="showP">
                                                            <tr v-for="(item, index) in LoadPersonalChar" :key="index">
                                                                <td><span class="badge badge-sucess">{{ index + 1 }}.</span></td>
                                                                <td>{{ item.assessment_area}}</td>
                                                                <td>{{ item.score_description}}</td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- for cfa -->
            <div class="row">
                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <div class="card card-outline">
                        <div class="card-body" id="cfa_part">
                            <div class="tab-content">
                                <div class="tab-pane fade show active" id="basicdetails" role="tabpanel" aria-labelledby="basicdetails-tab">
                                    <div class="form-group row">
                                        <div class="card-body col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                            <div class="form-group table-responsive">
                                                <table  class="table table-sm table-bordered table-striped ">
                                                    <thead class="p-3 mb-2 bg-secondary text-white border border-info">
                                                        <tr>
                                                            <!-- <th class="text-start" style='font-weight: bold;font-family: "Times New Roman", Times, serif;width:7%'>SN</th> -->
                                                            <th class="text-start" style='font-weight: bold;font-family: "Times New Roman", Times, serif;width:30%'>Subjects Name</th> 
                                                            <th class="text-start" style='font-weight: bold;font-family: "Times New Roman", Times, serif;width:40%'>Strands</th> 
                                                            <th class="text-start" style='font-weight: bold;font-family: "Times New Roman", Times, serif;width:30%'>Rating</th> 
                                                        </tr>
                                                    </thead>
                                                    <tbody id="FinalResult">
                                                        <tr v-for="(item, index) in CfaResultLists" :key="item.subjectname">
                                                            <template v-if="index === 0 || item.subjectname !== CfaResultLists[index - 1].subjectname">
                                                            
                                                                <td><b>{{ item.subjectname }}</b></td>
                                                                <td>{{ item.strand }}</td>
                                                                <td v-if="item.score =='Approaching'" class="text-danger">{{ item.score }}</td>
                                                                <td v-else>{{ item.score }}</td>
                                                            </template>
                                                            <template v-else>
                                                            
                                                                <td></td>
                                                                <td>{{ item.strand }}</td>
                                                                <td v-if="item.score =='Approaching'" class="text-danger">{{ item.score }}</td>
                                                                <td v-else>{{ item.score }}</td>
                                                            </template>
                                                        </tr>
                                                        <template>
                                                            <tr v-if="this.resultStatus=='1'">
                                                                <td colspan="2" class="text-right">Status:</td>
                                                                <td colspan="1" class="text-success"><b>Pass</b></td>
                                                            </tr>
                                                            <tr v-else >
                                                                <td colspan="2" class="text-right">Result:</td>
                                                                <td colspan="1" class="text-danger"><b>Fail</b></td>
                                                            </tr>
                                                            <tr>
                                                                <td colspan="1" class="text-right">Attendance Percentage:</td>
                                                                <td colspan="1"><b>{{this.cfaattendance}} %</b></td>
                                                            </tr>
                                                        </template>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    </template>
    <script>
    
    export default {
        data(){
            return{
                std_admission_details:'',
                studentDetails:'',
                genderArray:[],
                CsaResultLists:'',
                CfaResultLists:'',
                LoadPersonalChar:'',
                percentage:'',
                promoted:'0',
                resultStatus:'',
                Year:'',
                class_position:'',
                attendance:'',
                cfaattendance:'',
                instructional_day:'',
                no_of_days_attended:'',
                student_code:'',
                academic_year:'',
                total_of_student:'',
                class:'',
                stream:'',
                section:'',
                selectclass:'',
                academic_year:new Date().getFullYear(),
                academicYears: [],
                termStatus:'',
                commonExam:[],
                normalClasses:[],

                student_form: new form({
                    remarks:'',
                    academic_year:'',
                    term:'',
                })
            }
        },
    methods:{
        async getstudentPersonalDetails(type){
            await axios.get('/admissions/getStudentDetailsFromPortal/'+type)
                .then(response => {
                let data = response.data;
                if(data != "" || $data!=""){
                    this.student_id =data.id;
                    this.getStudentCurrentClass(data.id);
                    this.DateOfBirth = data.DateOfBirth;
                    this.student_form.DateOfBirth = data.DateOfBirth
                    this.std_admission_details=data;
                    this.getOrgDetails(data.OrgOrganizationId);
                    this.org_id = this.std_admission_details.OrgOrganizationId;
                }
            });
        },
        getOrgDetails(id){
            axios.get('/organizations/loadOrganizationDetailsbyOrgId/' +id)
            .then(response =>{
                let data = response.data.data;
                if(data!="" ||data!=null){
                    this.studentDetails = data;
				}	
            })
        },
        getStudentClass(year){
            this.normalClasses =[];
            this.commonExam = [];
            this.type ='Result';
            this.params = year+'__'+this.student_id+'__'+this.type;
            let uri = '/students/getStudentClassId/'+ this.params;
            try{
                axios.get(uri).then(response => {
                    let data= response.data;
                    if(data!="" && data!=null){
                        this.classId = data.organization_data[0].class_id;
                        this.selectclass = data.student_data[0].class;
                        if (this.selectclass === 'VI' || this.selectclass === 'VIII') {
                            this.termStatus = 'common';

                             //prepering temp array for displaying term Id
                            this.commonExam = [
                                { id: 1, label: 'Term 1' },
                                { id: 2, label: 'Term 2' },
                                { id: 3, label: 'Common Examination Result' }
                            ];
                        } else {
                            this.termStatus = 'Notcommon';
                            this.normalClasses = [
                                { id: 1, label: 'Term 1' },
                                { id: 2, label: 'Term 2' },
                                { id: 0, label: 'Final Result' }
                            ];
                        }
                    }
                });
            }catch(e){
                console.log('error loadactivedzongkhags '+e);
            }
        },
        //added to display current class and section
        getStudentCurrentClass(std_id){
          // Assuming std_id might or might not be defined
            const currentYear = new Date().getFullYear();
            this.type ='Result';
            this.params = currentYear + '__' + std_id +'__'+this.type;
            let uri = '/students/getStudentClassId/'+ this.params;
            try{
                axios.get(uri).then(response => {
                    let data= response.data;
                    if(data!="" && data!=null){
                        this.class = data.student_data[0].class;
                        // this.classId = data.organization_data[0].class_id;
                        this.section = data.student_data[0].section;
                        this.stream = data.student_data[0].stream;
                        this.Year = data.student_data[0].academicYear;
                    }
                });
            }catch(e){
                console.log('error loadactivedzongkhags '+e);
            }
        },
        LoadFinalResultByStudentId(term){
            this.CsaResultLists=[];
            this.CfaResultLists=[];
            this.term_year = this.academic_year+'__'+term+'__'+this.classId+'__'+this.selectclass;
            axios.get('results/LoadFinalResultByStudentId/' +this.student_code+ '/' + this.term_year)
                .then(response => {
                    if(response.data.data!="" && response.data.data!=null){
                        let data = response.data.data;
                        this.CsaResultLists=data;
                        this.CfaResultLists = data;
                        this.percentage = data[0].t_marks_percent;
                        this.promoted = data[0].t_promoted;
                        this.resultStatus = data[0].resultStatus;
                        this.class_position = data[0].t_position;
                        this.total_of_student = data[0].no_of_students;
                        this.attendance = data[0].t_attendance_percent;
                        this.cfaattendance = data[0].attendance;
                        this.instructional_day = data[0].t_instructional_days;
                        this.no_of_days_attended = data[0].t_no_of_days_attended;
                        $('#resultBody').show();
                        $('#FinalResult').show();
                        $('#admmissionD').show();
                        $('#NoFinalResult').hide();
                        $('#per').show();
                        $('#message').html("<b style='color:green'>Congratulations! Your result has been successfully published </b>");
                        $('status').show();
                        this.LoadPersonalCharaByStudentId();

                    }
                    else{
                        this.CsaResultLists=[];
                        this.CfaResultLists = [];
                        $('#term2').hide();
                        $('#parents_tab').hide();
                        $('#term1').hide();
                        $('#cfa_part').hide();
                        $('#personalH').hide();
                        $('#parents_tab').hide();
                        $('#resultH').hide();
                        $('#admmissionD').hide();
                        $('#FinalResult').hide();
                        $('#NoFinalResult').show();
                        
                        $('#per').hide();
                        $('#message').html("<b style='color:red'>No records found for selected year and term. Thank You</b>");
                        $('#status').hide();
                    }
                });
        },
        check_year(){
            let returntue=true;
            if($('#academic_year').val()==null){
                $('#academic_year_err').html('Please select academic year');
                $('#academic_year').focus();
                $('#academic_year').addClass('is-invalid');
                returntue=false;
            }
            return returntue;
        },

        LoadPersonalCharaByStudentId(){
            this.LoadPersonalChar = [];
            axios.get('results/LoadPersonalCharaByStudentId/' +this.student_code+ '/' +this.academic_year)
            .then(response => {
                if(response.data.data!="" && response.data.data!=null){
                    let data = response.data.data;
                    this.LoadPersonalChar=data;
                    $('#resultBody').show();
                    $('#showP').show();
                    $('#NoshowP').hide();
                    $('#per').show();
                }
                else{
                    $('#showP').hide();
                    $('#NoshowP').show();
                    $('#per').hide();
                }
            });
        },

        applyselect(){
            if(!$('#dzongkhag').attr('class').includes('select2')){
            $('#dzongkhag').addClass('select2');
            }
            if(!$('#school').attr('class').includes('select2')){
            $('#school').addClass('select2');
            }
            if(!$('#class').attr('class').includes('select2')){
            $('#class').addClass('select2');
            }
            if(!$('#stream').attr('class').includes('select2')){
            $('#stream').addClass('select2');
            }
        },

        loadGenderList(uri="masters/loadGlobalMasters/all_active_gender"){
            axios.get(uri)
            .then(response => {
                let data = response;
                this.sex_idList =  data.data.data;
                for(let i=0;i<data.data.data.length;i++){
                    this.genderArray[data.data.data[i].id] = data.data.data[i].name;
                }
            })
            .catch(function (error) {
                console.log(error);
            });
        },
        async CheckConfiguration(uri="CheckConfiguration/result"){
            axios.get(uri)
            .then(response => {
                let data = response.data;
                this.status =data.status;
                if(this.status==0){
                    $('#message').html("<b style='color:red'>Window for viewing result from portal is closed for now. Thank You</b>");
                    $('#result').hide();
                }
                else{
                    $('#result').show();
                }
                console.log(data.status);
                
            })
            .catch(function (error) {
                console.log(error);
            });
        },
        removeerror(fieldid){
            if($('#'+fieldid).val()!=""){
                $('#'+fieldid).removeClass('is-invalid');
            }
        },
    
        async changefunction(id){
            if($('#'+id).val()!=""){
                $('#'+id).removeClass('is-invalid');
                $('#'+id+'_err').html('');
                $('#'+id).addClass('select2');
            }
            if(id=="std_class"){
                this.student_form.class=$("#std_class option:selected" ).text();
            }
            if(id=="academic_year"){
                this.academic_year=$("#academic_year option:selected" ).text();
                this.getStudentClass(this.academic_year);
                // this.LoadFinalResultByStudentId(this.academic_year);
            } 
            if(id=="term"){
                this.term=$("#term" ).val();
                if(this.term ==2 || this.term == 0 || this.term== 3){
                    if(this.selectclass =='PP' || this.selectclass =='I' || this.selectclass =='II'|| this.selectclass =='III'){
                        $('#term1').hide();
                        $('#term2').hide();
                        $('#cfa_part').show();
                        $('#resultH').show();
                    }else{
                        $('#term1').hide();
                        $('#term2').show();
                        $('#personalH').show();
                        $('#parents_tab').show();
                        $('#resultH').show();
                    }
                    
                }
                else{
                    if(this.selectclass =='PP' || this.selectclass =='I' || this.selectclass =='II'|| this.selectclass =='III'){
                        $('#term1').hide();
                        $('#term2').hide();
                        $('#cfa_part').show();
                        $('#resultH').show();
                    }
                    else{
                        $('#term1').show();
                        $('#term2').hide();
                        $('#personalH').hide();
                        $('#parents_tab').hide();
                        $('#resultH').show();
                        $('#cfa_part').hide();
                    }
                }
                this.LoadFinalResultByStudentId(this.term);
            }    
        },
            showErrorMsg(text){
                Swal.fire({
                    html: text,
                    icon: 'error'
                });
            },
        },

        async mounted() {
            this.CheckConfiguration();
            const currentYear = new Date().getFullYear();
            this.academicYears = [currentYear, currentYear - 1, currentYear - 2, currentYear - 3];
            $('#personalH').hide();
            $('#resultH').hide();
            $('#parents_tab').hide();
            $('#term1').hide();
            $('#term2').hide();
            $('#cfa_part').hide();
            $('#message').html("<b style='color:blue'>Please select the year. </b>");
            $('#admmissionD').hide();
            $('#resultBody').hide();
            this.loadGenderList();
            $('.select2').select2();
            $('.select2').select2({
                theme: 'bootstrap4'
            });
            $('.select2').on('select2:select', function (el){
                Fire.$emit('changefunction',$(this).attr('id'));
            });
    
            Fire.$on('changefunction',(id)=> {
                this.changefunction(id);
            });
            axios.get('getSessionDetail')
            .then(response => {
                let data = response.data.data;
                this.student_code = data['email'];
                // this.LoadFinalResultByStudentId(this.email);
                // this.LoadPersonalCharaByStudentId(this.email);
                this.dob = data['dob'];
                this.id = data['id'];
                let user_type=data['user_type'];
                if(data['user_type']=="Student"){
                    this.student_form.student_id=data.id;
                    $('#selectStudent').hide();
                    this.getstudentPersonalDetails(user_type);
                }
            })
            .catch(errors => {
                console.log(errors)
            });
            $('#status').hide();
            
        },
        watch: {
            CsaResultLists(){
                this.$nextTick(() => {
                    this.dt =  $("#result-table").DataTable()
                });
            },
            LoadPersonalChar(){
                this.$nextTick(() => {
                    this.dt =  $("#chara-table").DataTable()
                });
            }
        },
    }
    </script>
    